import { FC, memo, useMemo } from 'react';
import { useController } from 'react-hook-form';

import FormControl from '@material-ui/core/FormControl';

import { HelperTxt } from '../helperTxt/HelperTxt';
import { IncrementInput } from '../incrementInput/IncrementInput';
import { FormIncrementInputProps } from './FormItems.types';

export const FormIncrementInput: FC<Omit<FormIncrementInputProps, 'onChange' | 'value'>> = memo(
  ({ control, name, required, requiredText, hideHelperText, ...rest }) => {
    const {
      field: { value, onChange },
      fieldState: { error },
    } = useController({
      name,
      control,
      defaultValue: '',
    });

    const helperText = useMemo(() => {
      if (error?.message) {
        return error.message;
      }

      if (required) {
        return requiredText || '*required';
      }

      return '';
    }, [error?.message, required, requiredText]);

    return (
      <FormControl error={!!error} fullWidth>
        <IncrementInput {...rest} value={value} error={!!error} onChange={onChange} />

        {!hideHelperText && helperText && <HelperTxt>{helperText}</HelperTxt>}
      </FormControl>
    );
  },
);
